/* Calcolo rate condiviso da banner e barra.
   Regola: si sceglie la durata piu' lunga la cui rata resta sopra il minimo.
   Verificata sui casi reali: 250 EUR -> 12 rate, 779 EUR -> 36 rate da 25,98. */
window.DemaRate=(function(){
 "use strict";
 var TAN_Y=0.1228;      /* Younited, TAN fisso */
 var TAEG_K=0.176;      /* Klarna, TAEG rate lunghe */
 var RATA_MIN=20;       /* sotto questa rata la finanziaria non concede */
 var DURATE=[36,24,12];
 var MIN_KLARNA_3=30;   /* sotto questo importo le 3 rate non hanno senso */

 function euro(n){return "\u20ac"+n.toLocaleString("it-IT",{minimumFractionDigits:2,maximumFractionDigits:2})}
 function rataTan(tot,n,tan){var i=tan/12;return tot*i/(1-Math.pow(1+i,-n))}
 function rataTaeg(tot,n,taeg){var i=Math.pow(1+taeg,1/12)-1;return tot*i/(1-Math.pow(1+i,-n))}

 /* Younited: durata piu' lunga sostenibile, o niente */
 function younited(tot){
  for(var i=0;i<DURATE.length;i++){
   var n=DURATE[i], r=rataTan(tot,n,TAN_Y);
   if(r>=RATA_MIN)return {n:n,rata:r};
  }
  return null;
 }
 /* Klarna: 3 rate a interessi zero, piu' l'alternativa a 12 */
 function klarna(tot){
  if(tot<MIN_KLARNA_3)return null;
  return {tre:tot/3, dodici:rataTaeg(tot,12,TAEG_K)};
 }
 return {euro:euro,younited:younited,klarna:klarna,TAN_Y:TAN_Y,TAEG_K:TAEG_K};
})();
